export default class CancelApiTokenEdit {
  constructor(context) {
    this.context = context;
  }

  run(id) {
    this.context.stores.apiTokens.clearErrors(id);
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/api_tokens/cancel_api_token_edit.js